import { render } from "./AgreePage.vue?vue&type=template&id=7ed2e877"
import script from "./AgreePage.vue?vue&type=script&lang=js"
export * from "./AgreePage.vue?vue&type=script&lang=js"

import "./AgreePage.vue?vue&type=style&index=0&id=7ed2e877&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__